module.exports = __webpack_public_path__ + "static/media/Recuerdos Mios.f38a20cc.jpg";